import SocialMediaCard from "@/components/social-media-card/social-media-card";
import { ContentButtonStyled, ContentThanksAndViewPostStyled } from "../../../../style-components";
import CustomButton from "@/components/custom-button/custom-button";

interface AlreadyParticipatedProps {
  postSaved: string;
  nameSocialMedia: string;
  loading: boolean;
  isExpiredMission: boolean;
  isComingSoon: boolean;
  isConnect: boolean;
  setModalSaveUrlPost: (value: boolean) => void;
}


const AlreadyParticipated: React.FC<AlreadyParticipatedProps>= ({ 
  postSaved, 
  nameSocialMedia,
  loading,
  isExpiredMission,
  isComingSoon,
  isConnect,
  setModalSaveUrlPost
}) => {
  return (
    <>
      <ContentThanksAndViewPostStyled>
        {postSaved ?
          <p className="thanks-text">¡Estamos validando tu publicación!</p>:
          <p className="search-text">Encontraremos tu publicación automáticamente, espera unos momentos...</p>
        }
        {postSaved && 
        <SocialMediaCard 
          url={postSaved} 
          socialMediaName={nameSocialMedia} 
        />}
      </ContentThanksAndViewPostStyled>
      {!postSaved && 
      <ContentButtonStyled>
        <CustomButton
          color="white"
          variant="outlined"
          disabled={loading || !nameSocialMedia || isExpiredMission || isComingSoon || !isConnect}
          onClick={() => {
            setModalSaveUrlPost(true);
          }}
          style={{ padding: '10px 24px', borderRadius: '40px', height: '40px' }}>
          Prefiero registrarla manualmente
        </CustomButton>
      </ContentButtonStyled>}
    </>
  )
  
};

export default AlreadyParticipated;